import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import {
    LIST_REPLAY_ROUTES,
    ListReplayRoutesResponse,
    ListReplayRoutesVariables,
    ReplayRouteBrief,
} from '../graphql/listReplayRoutes';
import {
    GET_REPLAY_ROUTE_DETAIL,
    GetReplayRouteDetailResponse,
    GetReplayRouteDetailVariables,
    ReplayRouteDetail,
} from '../graphql/getReplayRouteDetail';

/** 下拉选路项（G3 返回：value=dspTaskId, label=routeName） */
export type ReplayRouteOption = ReplayRouteBrief;

/**
 * 嵌入式回放数据编排：从父节点（区域）进入，不再级联选路。
 * G3 按 parentDspTaskId 拉本区域子路线做下拉；选中某条 → G4 拿详情。
 */
export function useReplayRoute(parentDspTaskId?: number) {
    // G3 子路线列表
    const { data: routesData } = useQuery<ListReplayRoutesResponse, ListReplayRoutesVariables>(LIST_REPLAY_ROUTES, {
        variables: { parentDspTaskId: parentDspTaskId as number },
        skip: parentDspTaskId == null,
    });
    const routes = routesData?.listReplayRoutes ?? [];

    const [selectedDspTaskId, setSelectedDspTaskId] = useState<number>();

    // 路线列表就绪、当前未选 → 默认选第一条
    useEffect(() => {
        if (selectedDspTaskId == null && routes.length > 0) setSelectedDspTaskId(routes[0].dspTaskId);
    }, [routes, selectedDspTaskId]);

    // G4 详情
    const { data } = useQuery<GetReplayRouteDetailResponse, GetReplayRouteDetailVariables>(GET_REPLAY_ROUTE_DETAIL, {
        variables: { dspTaskId: selectedDspTaskId as number },
        skip: selectedDspTaskId == null,
    });

    // 只有「选中路线的详情真正返回」才提交渲染，切换过程中保持上一次
    const [detail, setDetail] = useState<ReplayRouteDetail | null>(null);
    useEffect(() => {
        const fetched = data?.getReplayRouteDetail;
        if (fetched && selectedDspTaskId != null && fetched.route?.dspTaskId === selectedDspTaskId) {
            setDetail(fetched);
        }
    }, [data, selectedDspTaskId]);

    return {
        routes,
        selectedDspTaskId,
        selectRoute: setSelectedDspTaskId,
        detail,
    };
}
